export default __webpack_public_path__ + "static/media/collapseComponentImg.f21ecf3b.svg";